import React from 'react';
import { View, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  container: {
    marginTop: 10,
    width: 50,
    maxHeight: 50,
  },
  image: {
    borderRadius: 2,
    maxWidth: '100%',
    height: 'auto'
  }
});

const InvoiceHeaderLogo = ({ retailerInfo }) => {
  return (
    <View style={styles.container}>
      <Image style={styles.image} src={`${retailerInfo.logo_url}`} />
    </View>
  );
}

export default InvoiceHeaderLogo;